import React from 'react'
import PageHeader from '../PageHeader'
import { Col, Row } from 'antd'

const SectionWrapper = ({ title, rightComp, children }) => {
    return (
        <div className="flex flex-col gap-4">
            <PageHeader title={title} rightComp={rightComp} />
            {children}
        </div>
    )
}

export default SectionWrapper